import { HTTPError } from 'ky';

import api from '@/apis/api';
import { experienceApiRoutes } from '@/apis/experience/const';

const getErrorMessage = (body: unknown): string | undefined => {
  if (typeof body !== 'object' || body === null || !('message' in body)) {
    return;
  }

  return typeof body.message === 'string' ? body.message : undefined;
};

/**
 * Ask Logto Core to renew a DXM magic-link email.
 *
 * Core exchanges machine credentials for a gateway Bearer token; the browser
 * never sees `clientSecret`.
 */
export const renewMagicLink = async (email: string, clientId: string): Promise<void> => {
  try {
    await api.post(`${experienceApiRoutes.prefix}/one-time-token/renew`, {
      json: { email, clientId },
    });
  } catch (error: unknown) {
    if (error instanceof HTTPError) {
      const body: unknown = await error.response.json().catch(() => ({}));
      throw new Error(getErrorMessage(body) ?? 'Could not refresh the magic link.');
    }

    throw error instanceof Error ? error : new Error('Could not refresh the magic link.');
  }
};
